// extracted by mini-css-extract-plugin
export default {"carousel_container":"Carousel_carousel_container__E3BMh","info_icons":"Carousel_info_icons__ktqOz","icon_btn":"Carousel_icon_btn__KMsXG"};